import service from './../../../services/stock/item'
export default {
    namespaced: true,
    state: {
        data: [],
        params: {
            code: null,
            name: null
        },
        options: {},
        loading : false,
        length: 0,
        page: 1
    },
    getters: {
        params: state => state.params,
        options: state => state.options,
        data: state => state.data,
        loading: state => state.loading,
        length: state => state.length,
        page: state => state.page
    },
    mutations: {
        setOptions: (state, payload) => state.options = payload,
        setParams: (state, payload) => state.params[payload.key] = payload.value,
        setData: (state, payload) => state.data = payload,
        setLoading: (state, payload) => state.loading = payload,
        setLength: (state, payload) => state.length = payload,
        setPage: (state, payload) => state.page = payload
    },
    actions: {
        updateOptions(context, payload) {
            context.commit("setOptions", payload);
            context.dispatch("search");
        },
        updateParams(context, {key, value}) {
            context.commit("setParams", {key, value});
        },
        search(context){
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                service.index({...context.state.options, ...context.state.params}).then(response => {
                    context.commit("setData", response.data.data)
                    context.commit("setLength", response.data.count)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                }).finally(() => context.commit("setLoading", false))
            })
        },
        updatePage(context, payload) {
            context.commit("setPage", payload)
        }
    }
}